import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMaterialdesignComponent } from './simple-icons-materialdesign.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMaterialdesignComponent ],
    exports:      [ SimpleIconsMaterialdesignComponent ],
    bootstrap:    []
})
export class SimpleIconsMaterialdesignModule {}
